import businessSettings from "img/screenshots/epr_business_settings.png";
import payments from "img/screenshots/epr_payments.png";
import registrationNumbers from "img/screenshots/epr_settings_numbers.png";
import transactions from "img/screenshots/epr_transactions.png";
import reportingCalendar from "img/screenshots/epr_reporting_calendar.png";
import declarations from "img/screenshots/epr_declarations.png";
import helpCenter from "img/screenshots/epr_country_guides.png";
import { sgT } from "./translate";

export const EPR_START_GUIDE_STEP_IDS = {
  BUSINESS: "business",
  PAYMENTS: "payments",
  REGISTRATION: "registration",
  DATA: "data",
  CALENDAR: "calendar",
  DECLARATION: "declaration",
  HELP: "help",
};

export const eprStartGuideContent = {
  texts: {
    get subtitle() { return sgT("epr.subtitle"); },
    get allDone() { return sgT("epr.allDone"); },
    get showPreviousTasks() { return sgT("showPreviousTasks"); },
    tasksLeft: ({ tasksLeft, minutesLeft }) =>
      sgT("tasksLeft", { tasksLeft, minutesLeft }),
    get goal() { return sgT("epr.goal"); },
    get footerLinks() {
      return [
        { label: sgT("openHelpCenter"), to: "/help" },
        { label: sgT("epr.viewReportingCalendar"), to: "/report-calendar" },
      ];
    },
    get nextActions() {
      return [
        {
          title: sgT("epr.nextActions.declarations.title"),
          description: sgT("epr.nextActions.declarations.description"),
          label: sgT("epr.nextActions.declarations.label"),
          to: "/epr-reporting",
          variant: "primary",
        },
        {
          title: sgT("checkDocumentRequests"),
          description: sgT("epr.nextActions.messages.description"),
          label: sgT("openMessages"),
          to: "/messages",
        },
        {
          title: sgT("epr.nextActions.calendar.title"),
          description: sgT("epr.nextActions.calendar.description"),
          label: sgT("epr.nextActions.calendar.label"),
          to: "/report-calendar",
        },
      ];
    },
  },
  minutesPerTask: 5,
  defaultSteps: [
    {
      id: EPR_START_GUIDE_STEP_IDS.BUSINESS,
      step: EPR_START_GUIDE_STEP_IDS.BUSINESS,
      get name() { return sgT("businessDetails.name"); },
      category: "required",
      complete: false,
    },
    {
      id: EPR_START_GUIDE_STEP_IDS.PAYMENTS,
      step: EPR_START_GUIDE_STEP_IDS.PAYMENTS,
      get name() { return sgT("paymentDetails.name"); },
      category: "required",
      complete: false,
    },
    {
      id: EPR_START_GUIDE_STEP_IDS.REGISTRATION,
      step: EPR_START_GUIDE_STEP_IDS.REGISTRATION,
      get name() { return sgT("epr.steps.registration.name"); },
      category: "recommended",
      optional: true,
      complete: false,
    },
    {
      id: EPR_START_GUIDE_STEP_IDS.DATA,
      step: EPR_START_GUIDE_STEP_IDS.DATA,
      get name() { return sgT("epr.steps.data.name"); },
      category: "recommended",
      optional: true,
      complete: false,
    },
    {
      id: EPR_START_GUIDE_STEP_IDS.CALENDAR,
      step: EPR_START_GUIDE_STEP_IDS.CALENDAR,
      get name() { return sgT("epr.steps.calendar.name"); },
      category: "learn",
      complete: false,
    },
    {
      id: EPR_START_GUIDE_STEP_IDS.DECLARATION,
      step: EPR_START_GUIDE_STEP_IDS.DECLARATION,
      get name() { return sgT("epr.steps.declaration.name"); },
      category: "optional",
      optional: true,
      requires: [EPR_START_GUIDE_STEP_IDS.REGISTRATION],
      get lockReason() { return sgT("epr.steps.declaration.lockReason"); },
      complete: false,
    },
    {
      id: EPR_START_GUIDE_STEP_IDS.HELP,
      step: EPR_START_GUIDE_STEP_IDS.HELP,
      get name() { return sgT("help.name"); },
      category: "learn",
      optional: true,
      complete: false,
    },
  ],
  steps: {
    [EPR_START_GUIDE_STEP_IDS.BUSINESS]: {
      get name() { return sgT("businessDetails.name"); },
      get description() { return sgT("businessDetails.description"); },
      to: "/business-settings?tab=business",
      get actionLabel() { return sgT("fill"); },
      image: businessSettings,
    },
    [EPR_START_GUIDE_STEP_IDS.PAYMENTS]: {
      get name() { return sgT("paymentDetails.name"); },
      get description() { return sgT("epr.steps.payments.description"); },
      to: "/product-settings/payments",
      get actionLabel() { return sgT("fill"); },
      image: payments,
    },
    [EPR_START_GUIDE_STEP_IDS.REGISTRATION]: {
      get name() { return sgT("epr.steps.registration.name"); },
      get description() { return sgT("epr.steps.registration.description"); },
      to: "/settings",
      get actionLabel() { return sgT("fill"); },
      image: registrationNumbers,
      get secondaryActions() {
        return [{ label: sgT("epr.steps.registration.track"), to: "/settings" }];
      },
      get learnMore() { return { label: sgT("learnMore"), to: "/help" }; },
    },
    [EPR_START_GUIDE_STEP_IDS.DATA]: {
      get name() { return sgT("epr.steps.data.name"); },
      get description() { return sgT("epr.steps.data.description"); },
      to: "/transactions",
      get actionLabel() { return sgT("fill"); },
      image: transactions,
      get learnMore() { return { label: sgT("learnMore"), to: "/help" }; },
    },
    [EPR_START_GUIDE_STEP_IDS.CALENDAR]: {
      get name() { return sgT("epr.steps.calendar.name"); },
      get description() { return sgT("epr.steps.calendar.description"); },
      to: "/report-calendar",
      get actionLabel() { return sgT("epr.steps.calendar.action"); },
      image: reportingCalendar,
    },
    [EPR_START_GUIDE_STEP_IDS.DECLARATION]: {
      get name() { return sgT("epr.steps.declaration.name"); },
      get description() { return sgT("epr.steps.declaration.description"); },
      to: "/epr-reporting",
      get actionLabel() { return sgT("fill"); },
      image: declarations,
    },
    [EPR_START_GUIDE_STEP_IDS.HELP]: {
      get name() { return sgT("help.name"); },
      get description() { return sgT("epr.steps.help.description"); },
      to: "/help",
      get actionLabel() { return sgT("openHelpCenter"); },
      image: helpCenter,
    },
  },
};
